export const environment = {
  URL: process.env.REACT_APP_API_URL,
  APP_URL: process.env.REACT_APP_URL,
};


